<template>
  <v-container class="p5-4 my-5">
    <v-spacer></v-spacer>
    <!-------------show if the data is still being fetched ------------------->
    <v-progress-linear indeterminate v-if="loading" color="var(--purple)"></v-progress-linear>
    <!------------------show error herer if any ---------------------->

    <v-card elevation="0" class="text-center error pink--text lighten-4 py-4" color=" danger lighten-4" v-if="error">
      <v-icon x-large color="pink darken-1">mdi-emoticon-sad-outline</v-icon>
      <h3 class="mt-1, mb-4">Oops!</h3>
      <p class="pink--text" color="pink darken-1" v-html="error"></p>
    </v-card>

    <!---------if match is found ----------------->
    <v-list dense v-if="result" class="d-flex flex-wrap">
      <!--match found-->
      <div class="success--text text-capitalize small d-flex justify-flex-end">
        <h5>{{ result.length }} match found</h5>
      </div>
      <!--list result here-->
      <!--     <v-list-item v-for="link in result" :key="link.id" class="ma-2" :to="{ name: 'pdf-viewer', params: { id: link.id } }"
        @click="downloadFile(link.id)">
        <v-list-item-avatar tile size="100" color="grey lighten-3"></v-list-item-avatar> -->

      <v-list-item v-for="link in result" :key="link.id" class="ma-2" @click="downloadFile(link.id)">
        <v-list-item-avatar tile size="100" color="grey lighten-3"></v-list-item-avatar>
        <v-list-item-content>
          <div class="text-overline mb-4 text-uppercase">
            {{ link.type }}
          </div>
          <v-list-item-title class="text-bold mb-2 text-uppercase">
            {{ link.file_name }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-capitalize truncate">{{
              link.file_description
          }}</v-list-item-subtitle>
        </v-list-item-content>
        <!--action option-->
      </v-list-item>
    </v-list>
    <!--pagination-->
    <div class="text-center d-none">
      <v-pagination v-model="page" total-visible="4" :length="length" prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"></v-pagination>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loading: false,
      error: null,
      result: null,
      page: 1,
      length: 0,
    };
  },
  created() {
    //fetch data when view is created and already being observed
    this.fetch_data();
  },
  watch: {
    //call fetched data method again if route changes
    $route: "fetch_data",
  },

  methods: {
    async fetch_data() {
      this.loading = true;
      this.error = this.result = null;
      const query = this.$route.params.query;
      // use search filter to modify result
      const filters = this.$route.params.filters;
      const { data: response } = await axios.get(`files/search?query=${query}&filters=${filters}`);
      console.log(JSON.stringify(response));
      //be sure the query is the  most recent
      if (this.$route.params.query !== query) {
        return;
      }
      //cancel loading action on response
      if (response) {
        this.loading = false;
      }
      //if error is giver, return the error
      this.result = response.data;
      this.length = response.data.length;

    },

    /**
     * @function downloadFile 
     * @param {string} fileId
     * send file Id to the server,
     * the server prompts for download
     */
    async downloadFile(fileId) {
      try {
        await axios.get(`/files/download/${fileId.trim()}`);
      } catch (error) {
        console.log(error.message);
      }
      // console.log(response);
    },
  }
};
</script>

<style scoped>
.truncate {
  width: 50px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>